import { File, FileArchive, FileAudio, FileCode, FileImage, FileSpreadsheet, FileTerminal, FileText, FileVideo, Folder, Presentation } from "lucide-react";
import { extOf } from "../lib/format";

export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <rect width="32" height="32" rx="8" fill="var(--accent)" />
      <path d="M9 11.5c0-1.1.9-2 2-2h3.6l1.8 2H21c1.1 0 2 .9 2 2V21c0 1.1-.9 2-2 2H11c-1.1 0-2-.9-2-2z" fill="none" stroke="var(--accent-ink)" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M16 20.5v-5.5m0 0-2.2 2.2M16 15l2.2 2.2" fill="none" stroke="var(--accent-ink)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function MicrosoftMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 21 21" className={className} aria-hidden>
      <rect x="1" y="1" width="9" height="9" fill="var(--ms-red)" />
      <rect x="11" y="1" width="9" height="9" fill="var(--ms-green)" />
      <rect x="1" y="11" width="9" height="9" fill="var(--ms-blue)" />
      <rect x="11" y="11" width="9" height="9" fill="var(--ms-yellow)" />
    </svg>
  );
}

const byExt: Record<string, typeof File> = {};
const add = (icon: typeof File, exts: string) => exts.split(" ").forEach((e) => (byExt[e] = icon));
add(FileText, "txt md pdf doc docx rtf odt");
add(FileSpreadsheet, "xls xlsx xlsm csv ods");
add(Presentation, "ppt pptx odp key");
add(FileImage, "png jpg jpeg gif webp svg bmp heic tif tiff");
add(FileVideo, "mp4 mov avi mkv webm wmv");
add(FileAudio, "mp3 wav m4a aac flac ogg");
add(FileArchive, "zip 7z rar gz tar tgz bz2 xz iso");
add(FileCode, "json xml html htm css ts tsx jsx py java cs sql yaml yml sh");
add(FileTerminal, "exe msi bat cmd ps1 vbs scr com jar dll");

export function FileIcon({ name, folder, className = "size-5" }: { name: string; folder?: boolean; className?: string }) {
  if (folder) return <Folder className={`${className} text-accent-text`} fill="currentColor" fillOpacity={0.15} aria-hidden />;
  const Icon = byExt[extOf(name)] ?? File;
  return <Icon className={`${className} text-muted`} aria-hidden />;
}
